import React from "react";
import "./RecentEntries.css";
import RecentEntriesTable from "./RecentEntriesTable";

const RecentEntries = () => {
  return (
    <div className="operator-entries-container">
      <RecentEntriesTable />
    </div>
  );
};

export default RecentEntries;
